import * as React from "react";

import Modal from "@mui/material/Modal";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { capitalizeFirstLetter } from "../../../../../utils/helperFunc";

export default function LoadsModal({
  openModal,
  handleClose,
  loadType,
  palletLoads,
  vehicleLoads,
  stonesLoads,
  sandLoads,
  lateriteLoads,
  barrelLoads,
}) {
  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="mui-customized"
      >
        <div>
          <div className="view-all-load-modal">
            <h1 className="large-text text-center"> All Loads </h1>

            <button className="close-modal-icon" onClick={handleClose}>
              <i className="fa-solid fa-xmark"></i>
            </button>

            <section className="load-post-loder-section">
              <div className="container">
                {/* Vehicle Loader  */}
                {vehicleLoads?.map((item, index) => (
                  <Accordion key={item.id} className="mt-2">
                    <div className="loader-tittle">
                      <AccordionSummary className="p-0">
                        <h1>
                          {capitalizeFirstLetter(loadType)} loader ({index + 1})
                          <i className="fa-solid fa-angle-right"></i>
                        </h1>
                      </AccordionSummary>
                    </div>

                    <AccordionDetails className="p-0">
                      <VehicleLoad item={item} />
                    </AccordionDetails>
                  </Accordion>
                ))}

                {/* Pallet Loader  */}
                {palletLoads?.map((item, index) => (
                  <Accordion className="mt-2" key={item.id}>
                    <div className="loader-tittle">
                      <AccordionSummary className="p-0">
                        <h1>
                          {capitalizeFirstLetter(loadType)} loader ({index + 1})
                          <i className="fa-solid fa-angle-right"></i>
                        </h1>
                      </AccordionSummary>
                    </div>

                    <AccordionDetails className="p-0">
                      <PalletLoad item={item} />
                    </AccordionDetails>
                  </Accordion>
                ))}

                {/* stones Loader  */}
                {stonesLoads?.map((item, index) => (
                  <Accordion className="mt-2" key={item.id}>
                    <div className="loader-tittle">
                      <AccordionSummary className="p-0">
                        <h1>
                          {capitalizeFirstLetter(loadType)} loader ({index + 1})
                          <i className="fa-solid fa-angle-right"></i>
                        </h1>
                      </AccordionSummary>
                    </div>

                    <AccordionDetails className="p-0">
                      <StonesLoad item={item} />
                    </AccordionDetails>
                  </Accordion>
                ))}

                {/* Sand Loader  */}
                {sandLoads?.map((item, index) => (
                  <Accordion className="mt-2" key={item.id}>
                    <div className="loader-tittle">
                      <AccordionSummary className="p-0">
                        <h1>
                          {capitalizeFirstLetter(loadType)} loader ({index + 1})  
                          <i className="fa-solid fa-angle-right"></i>
                        </h1>
                      </AccordionSummary>
                    </div>

                    <AccordionDetails className="p-0">
                      <SandLoad item={item} />
                    </AccordionDetails>
                  </Accordion>
                ))}

                {/* Laterite Load  */}
                {lateriteLoads?.map((item, index) => (
                  <Accordion className="mt-2" key={item.id}>
                    <div className="loader-tittle">
                      <AccordionSummary className="p-0">
                        <h1>  
                          {capitalizeFirstLetter(loadType)} loader ({index + 1})
                          <i className="fa-solid fa-angle-right"></i>
                        </h1>
                      </AccordionSummary>
                    </div>

                    <AccordionDetails className="p-0">  
                      <LateriteLoad item={item} />
                    </AccordionDetails>
                  </Accordion>
                ))}
                
                {/* Barrel Load  */}
                {barrelLoads?.map((item, index) => (
                  <Accordion className="mt-2" key={item.id}>
                    <div className="loader-tittle">
                      <AccordionSummary className="p-0">
                        <h1>
                          {capitalizeFirstLetter(loadType)} loader ({index + 1})
                          <i className="fa-solid fa-angle-right"></i>
                        </h1>
                      </AccordionSummary>
                    </div>

                    <AccordionDetails className="p-0" item={item}>
                      <BarrelLoad item={item}/>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            </section>
          </div>
        </div>
      </Modal>
    </div>
  );
}

const VehicleLoad = ({ item }) => {
  return (
    <div className="loader-full-details">
      <div className="row profile-info-section-wrapper">

        <div className="col-lg-4 profile-info-boxes">
          <label>Vehicles Brand</label>
          <p>{item?.brand}</p>
        </div>

        <div className="col-lg-4 profile-info-boxes">
          <label>Vehicles Model</label>
          <p>{item?.model}</p>
        </div>

        <div className="col-lg-4 profile-info-boxes">
          <label>Vehicle Type</label>
          <p>{item?.vehicle_type}</p>
        </div>

        <div className="col-lg-4 profile-info-boxes">
          <label>Vehicles State/Region</label>
          <p>{item?.state}</p>
        </div>

        <div className="col-lg-4 profile-info-boxes">
          <label>Vehicles License Plate</label>
          <p>{item?.license_plate}</p>
        </div>

        <div className="col-lg-4 profile-info-boxes">
          <label>Vehicles Year</label>
          <p>{item?.year}</p>
        </div>
        <div className="col-lg-4 profile-info-boxes">
          <label>Vehicles Lot Number</label>
          <p>{item?.lot_number}</p>
        </div>
        <div className="col-lg-4 profile-info-boxes">
          <label>Vehicles Color</label>
          <p>{item?.color}</p>
        </div>
        <div className="col-lg-4 profile-info-boxes">
            <label>Vehicles Additional Information</label>
            <p>{item?.additional_information}</p>
          </div>
      </div>
    </div>
  );
};

const PalletLoad = ({ item }) => {
  return (
    <>
      <div className="loader-full-details">
        <div className="row profile-info-section-wrapper">
          <div className="col-lg-4 profile-info-boxes">
            <label>Name</label>
            <p>{item?.name}</p>
          </div>

          <div className="col-lg-4 profile-info-boxes">
            <label>Weight</label>
            <p>{item?.weight}</p>
          </div>
          <div className="col-lg-4 profile-info-boxes">
            <label>Height</label>
            <p>{item?.height}</p>
          </div>
          <div className="col-lg-4 profile-info-boxes">
            <label>Width</label>
            <p>{item?.width}</p>
          </div>
          <div className="col-lg-4 profile-info-boxes">
            <label>Length</label>
            <p>{item?.length}</p>
          </div>
        </div>
      </div>
    </>
  );
};

const BarrelLoad = ({ item }) => {
  
  return (
    <>
      <div className="loader-full-details">
        <div className="row profile-info-section-wrapper">
          <div className="col-lg-4 profile-info-boxes">
            <label>Name</label>
            <p>{item?.name}</p>
          </div>

          <div className="col-lg-4 profile-info-boxes">
            <label>Weight</label>
            <p>{item?.weight}</p>
          </div>
        </div>
      </div>
    </>
  );
};

const SandLoad = ({ item }) => {
  
  return (
    <>
      <div className="loader-full-details">
        <div className="row profile-info-section-wrapper">
          <div className="col-lg-4 profile-info-boxes">
            <label>Total Trips</label>
            <p>{item?.total_trips}</p>
          </div>
          </div>
      </div>
    </>
  );
};

const LateriteLoad = ({ item }) => {
  return (
    <>
      <div className="loader-full-details">
        <div className="row profile-info-section-wrapper">
          <div className="col-lg-4 profile-info-boxes">
            <label>Total Trips</label>
            <p>{item?.total_trips}</p>
          </div>
        </div>
      </div>
    </>
  );
};

const StonesLoad = ({ item }) => {
  
  return (
    <>
      <div className="loader-full-details">
        <div className="row profile-info-section-wrapper">
          <div className="col-lg-4 profile-info-boxes">
            <label>Total Trips</label>
            <p>{item?.total_trips}</p>
          </div>
          </div>
      </div>
    </>
  );
};
